<template>
  <div class="step3">
    <a-result status="success" title="申请成功" sub-title="请及时支付款项">
      <template #extra>
        <a-button
          v-if="bank && ct.projects && ct.projects.status == 2 && ct.poundage > 0"
          type="primary"
          @click="gopay"
        >
          去付款
        </a-button>
        <a-button @click="back"> 返回 </a-button>
      </template>
    </a-result>
    <input id="input" style="opacity: 0; position: absolute" />
    <div class="desc-wrap" >
      <a-descriptions :column="2" title="付款信息">
        <a-descriptionsItem label="项目名称">
          {{ ct.project }}
        </a-descriptionsItem>
        <a-descriptionsItem label="付款时间">
          <div class="text-red-500">请在 {{ ct.kbdate }} 前支付</div>
        </a-descriptionsItem>
        <a-descriptionsItem label="账户名称">
          {{ setting.invoice_title
          }}<a-icon type="copy" class="cursor-pointer" @click="copy(setting.invoice_title)" />
        </a-descriptionsItem>
        <a-descriptionsItem label="开户行">
          {{ setting.invoice_bank }}
          <a-icon type="copy" class="cursor-pointer" @click="copy(setting.invoice_bank)"
        /></a-descriptionsItem>
        <a-descriptionsItem label="开户行账号">
          {{ setting.invoice_bank_account }}
          <a-icon type="copy" class="cursor-pointer" @click="copy(setting.invoice_bank_account)" />
        </a-descriptionsItem>
        <a-descriptionsItem label="开户行行号">
          {{ setting.bank_code
          }}<a-icon type="copy" class="cursor-pointer" @click="copy(setting.bank_code)" />
        </a-descriptionsItem>
        <a-descriptionsItem label="金额">
          <div class="text-red-500">
            {{ ct.poundage ? ct.poundage.toFixed(2) : '' }}({{
              convertCurrency(parseFloat(ct.poundage ? ct.poundage.toFixed(2) : ''))
            }})
            <a-icon
              type="copy"
              class="text-black cursor-pointer"
              @click="copy(ct.poundage ? ct.poundage.toFixed(2) : '')"
            />
          </div>
        </a-descriptionsItem>
        <a-descriptionsItem>
          <div class="flex" style="transform: translateX(-109px)"
            ><span class="block mt-2 text-2xl font-bold text-red-500">*</span>
            <span class="mt-2">汇款用途附言: </span
            ><span class="text-3xl font-bold text-red-500 pl-3">{{ ct.code }}</span>
            <a-icon type="copy" class="mt-3 cursor-pointer" @click="copy(ct.code)" />
          </div>
        </a-descriptionsItem>
        <a-descriptions-item label="推荐码">{{
          ct.p_user_id > 0 ? ct.p_user_id : ''
        }}</a-descriptions-item>
        <a-descriptions-item label="申请人">{{ ct.bidder }}</a-descriptions-item>
        <a-descriptions-item label="付款链接"
          ><span style="color: red; font-weight: 400">{{ paysms() }}</span>
          <a-icon type="copy" class="cursor-pointer" @click="copy(paysms())"
        /></a-descriptions-item>
        <a-descriptionsItem label="开户许可证" v-if="ct.temp.is_certificate">
          <div class="overflow-hidden">
            <CertificateUpload
              :src="ct.company.certificate_src"
              @upload="certUpload"
            ></CertificateUpload>
          </div>
        </a-descriptionsItem>
        <a-descriptionsItem label="操作">
          <a-button type="primary" @click="copy(copyall(0))">
            <a-icon type="copy" class="cursor-pointer" />
            复制全部
          </a-button>
          <a-button type="primary" @click="smssend(ct)" :disabled="smsbuttonFlag">
            发送短信
          </a-button>
        </a-descriptionsItem>
      </a-descriptions>
      <div class="text-red-500">
        <div class="text-base font-bold">温馨提示</div>
        <div
          >1．保函费汇款转账
          <span class="text-2xl font-bold text-red-500">用途或附言</span
          >内容，除序列号以外，请勿备注其他内容。
        </div>
        <div> 2．如果不是从基本户付款或者登记的基本户账号有误，因此造成的后果由贵公司负责。 </div>
        <!-- <div>
          3．如果一个小时或者更长时间未出函，请
          <a-upload
            :before-upload="beforeUpload"
            :customRequest="api"
            accept="image/jpeg,image/png"
            :show-upload-list="false"
          >
            <a disabled v-if="loading">上传中</a>
            <a v-else>{{ isUpload ? '重新上传打款凭证' : '上传打款凭证' }}</a>
          </a-upload>
          ，并联系客服人员。
        </div> -->
        <div> 3．为防止企业客户信息被泄露，预防措施必不可少，故项目信息开标后解密 </div>
        <div>
          4．因银行转账存在延迟的问题，请尽量在项目开标或保证金缴纳截至时间前2小时完成支付。
        </div>
      </div>
    </div>
    <div class="h-8"></div>
    <SmssendForm
      :visible="smsFlag"
      :info="ct"
      @cancel="() => (smsFlag = false)"
      @ok="smssendForm"
    ></SmssendForm>
     <!-- 右侧：付款流水 -->
        <a-card  title="付款流水" style="flex: 1 1 360px; min-width: 360px;" :bodyStyle="{ padding: '12px' }">
          <!-- 动态提示条 -->
<div

  :style="{
    background: isBound ? '#f6ffed' : '#fffbe6',
    border: isBound ? '1px solid #b7eb8f' : '1px solid #ffe58f',
    color: isBound ? '#52c41a' : '#d46b08',
    padding: '8px 12px',
    borderRadius: '4px',
    marginBottom: '12px',
    display: 'flex',
    alignItems: 'center',
    gap: '6px',
    fontSize: '13px'
  }"
>
  <a-icon :type="isBound ? 'check-circle' : 'exclamation-circle'"
          :style="{ color: isBound ? '#52c41a' : '#faad14' }" />
  {{ isBound ? '此保函已被绑定，如需换绑请联系工作人员' :
              '款项到账后请及时在下方列表中选择对应的流水号后，点击"确认并提交"按钮，预计15分钟内出函！' }}
</div>
          <a-radio-group v-model="selectedSerial" style="width: 100%;">
            <a-list :dataSource="serialList" style="max-height: 420px; overflow-y: auto;">
              <a-list-item slot="renderItem" slot-scope="item">
                <a-radio :value="item.id" style="width: 100%;">
                  <div style="display: flex; flex-direction: column; line-height: 1.6;">
                    <!-- 第一行：创建时间 + 金额 -->
                    <div>
                      <span style="margin-right: 8px;">{{ item.createTime }}</span>
                      <span style="color: red; font-weight: 600;">¥{{ (item.amount || 0).toFixed(2) }}</span>
                    </div>
                    <!-- 第二行：流水号 -->
                    <div style="color: #666; font-size: 12px;">流水号：{{ item.serialNo }}</div>
                    <!-- 第三行：备注 -->
                    <div style="color: #999; font-size: 12px;">备注：{{ item.remark || '-' }}</div>
                  </div>
                </a-radio>
              </a-list-item>
            </a-list>
          </a-radio-group>

          <!-- 底部按钮 -->
        
           
           <div style="margin-top: 12px; text-align: center;">
              <a-input 
    v-model="submitRemark"
    placeholder="请输入备注"
    style="width: 220px;margin-right: 10px;"
    allow-clear
  />
  <a-button
    type="primary"
    ghost
    style="margin-right: 8px"
    @click="refreshSerial"
  >
    刷新付款流水
  </a-button>
  <!-- 已绑定时直接不渲染 -->
  <a-button
    v-if="!isBound"
    type="primary"
    @click="confirmSubmit"
  >
    确认并提交
  </a-button>
</div>
          
        </a-card>
        
      </div>
 
</template>
<script>
  import CertificateUpload from '@/components/CertificateUpload/index';
  import { config } from '@/api/config';
  import { banks } from '@/api/bank';
  import { convertCurrency } from '@/utils/transContent';
  import { companyCertificateModify } from '@/api/company';
  import SmssendForm from '@/views/admin/contract/step/module/smssend-form.vue';
  import { message } from 'ant-design-vue';
  import { bcdls,bind_contract ,review} from '@/api/bcdl';
  export default {
    components: {
      CertificateUpload,
      SmssendForm,
    },
    props: {
      ct: {
        type: Object,
        default: () => {},
      },
    },
    data() {
      return {
         queryParam: { custom: {}, time: {}, in: {}, like: {} ,eq:{} },
          isBound:false,
        selectedSerial: null,   // 当前选中的流水 id
    serialList: [],          // 流水数组，格式见下方
    submitRemark:"",
        setting: {},
        banklist: [],
        company: {},
        smsFlag: false,
        smsbuttonFlag: false,
      };
    },
    async mounted() {
      this.banklist = (await banks({ current: -1 })).data || {};
      this.setting = (await config()) || {};
    },
    computed: {
      bank() {
        if (this.ct.bankName) {
          return this.banklist.find((e) => {
            return this.ct.bankName.indexOf(e.name) >= 0;
          });
        } else {
          return null;
        }
      },
    },
    watch: {
      ct(a) {
        console.log(a);
      },
    },
    methods: {
      // 按钮点击直接调用
async handleAutoReview() {
  // 1. 先上传正式 PDF（拿到 file_id）
  // 这里假设你已经上传完成，file_id 存在 this.ct.file_id
  const postData = {
    id: this.ct.id,                    // 保函主键
    version: this.ct.version,          // 并发版本号
    content: this.ct.content,        // 审核意见
    content_2: this.ct.content_2,                     // 第二意见
    sign_type: this.ct.sign_type,                      // 1=电子章
    file_id: this.ct.file_id,          // 正式 PDF 文件 id
    file_id2: this.ct.file_id2,                       // 无第二文件
    text: this.ct.text,               // 操作记录备注
    temp_pos: this.ct.temp_pos,                      // 无印章坐标
    project_temp_pos: this.project_temp_pos,              // 无项目级坐标
    is_pass: true                      // 通过
  };

  try {
    await review(postData);            // 导出的 review 方法
    this.$message.success('审核成功');
    // 2. 刷新当前页面数据
   
  } catch (e) {
    this.$message.error('审核失败：' + (e.message || '请重试'));
  }
},
       async loadSerialList() {
        console.log(this.ct.status)
       if (this.info.status==4||this.info.status==3){
        this.isBound=false;
       }else{ this.isBound=true;}
        const params11 = {
  like: {},
  like_l: {},
  eq: {
    is_writeoff: 0,
    acctName: this.ct.bidder,   // 新增
    crAmt: this.ct.poundage    // 新增
  },
  in: { pay_type: [1, 6] },
  time: {},
  custom: {}
};
let res = await bcdls({
  
        qp: JSON.stringify(params11),
      },);  console.log(params11)
      this.serialList = (res.data || []).map(item => ({
          id: item.id,                       // 单选需要的 value
          createTime: item.tranDate,      // 第一行左边
          amount: parseFloat(item.crAmt || 0), // 第一行右边金额
          serialNo: item.voucher_no + '',            // 第二行流水号（这里直接用 id，你改真实字段）
          remark: item.postscript || '-'         // 第三行备注
        }))
    // TODO: 调接口赋值 this.serialList
    // 示例格式：
    // this.serialList = [
    //   { id: 1, createTime: '2025-09-10 14:23', amount: 1200.00, serialNo: 'SN202509101423', remark: '基本户转出' },
    //   ...
    // ]
  },
 
  // 刷新按钮
  refreshSerial() {
    this.loadSerialList()
  },
  // 确认并提交
  async confirmSubmit() {
    if (!this.selectedSerial) {
      this.$message.warning('请先选择一条流水')
      return
    }
    
const row = this.serialList.find(r => r.id === this.selectedSerial);
  if (!row) return;
    // TODO: 提交选中流水
   
     const params3 = {
    bankAccount:this.ct.bankAccount,
     bcdl_ids: String(row.id),
    bidder: this.ct.bidder,
    contract_id: this.ct.id,   
    poundage: this.ct.poundage,
    text: this.submitRemark
  };
console.log(params3)
  try {
     this.handleAutoReview()
     await new Promise(r => setTimeout(r, 500))
    const res = await bind_contract(params3);
    console.log('提交成功', res);
    this.$message.success('提交成功');
    location.reload(true);
    this.submitRemark = '';          // 清空备注
    await this.get();
  } catch (e) {
    console.error('提交失败', e);
    this.$message.error('提交失败：' + (e.message || '请重试'));
  }
    console.log('选中流水ID:', this.selectedSerial)
  },
      convertCurrency,
      back() {
        this.$router.push(`/admin/contract_detail/${this.ct.id}`);
      },
      gopay() {
        window.open(this.bank ? this.bank.link : '', 'target', '_blank');
      },
      copyall() {
        return `项目名称 : ${this.ct.project}
账户名称 : ${this.setting.invoice_title}
开户行账号 : ${this.setting.invoice_bank_account}
开户行 : ${this.setting.invoice_bank}
开户行行号 : ${this.setting.bank_code}
金额 : ¥ ${this.ct.poundage}(${convertCurrency(parseFloat(this.ct.poundage.toFixed(2)))})
申请人 : ${this.ct.bidder}
汇款用途附言 : ${this.ct.code}
付款链接:${this.paysms()}`;
      },
      copy(str) {
        // 创建临时的 textarea 元素（支持换行符）
        const textarea = document.createElement('textarea');
        // 设置样式确保不可见
        textarea.style.position = 'fixed';
        textarea.style.opacity = '0';
        textarea.style.left = '-9999px';
        textarea.style.top = '0';
        textarea.setAttribute('readonly', ''); // 防止移动端键盘弹出
        // 设置要复制的文本（保留换行符）
        textarea.value = str;
        // 添加到DOM中
        document.body.appendChild(textarea);
        // 选中文本
        textarea.select();
        textarea.setSelectionRange(0, textarea.value.length);

        try {
          // 执行复制命令
          const result = document.execCommand('copy');
          if (result) {
            message.success('复制成功');
          } else {
            console.error('复制命令执行失败');
          }
        } catch (e) {
          console.error('复制失败，请重试~', e);
        } finally {
          // 无论如何都移除临时元素
          document.body.removeChild(textarea);
        }
      },
      smssend() {
        this.smsFlag = true;
      },
      async smssendForm() {
        this.smsbuttonFlag = true;
      },
      paysms() {
        return `【金电保】尊敬的先生/女士：${this.ct.bidder}保函编号${
          this.ct.prefix + this.ct.code
        }已审核，请及时支付www.jdbsk.com/api/v1/m/view/${this.ct.code}/${this.ct.uuid}`;
      },
      async certUpload(res) {
        this.company = this.ct.company;
        try {
          this.spinning = true;
          this.company.certificate_id = res.id;
          this.company.certificate_src = res.pathname;
          await companyCertificateModify(this.company);
        } catch (error) {
          this.$error({ title: '错误提示', content: error });
        } finally {
          this.spinning = false;
        }
      },
    },
  };
</script>
<style lang="less" scoped>
  .step3 {
    width: 960px;
    margin: 0 auto;
  }

  .desc-wrap {
    padding: 24px 40px;
    margin-top: 24px;
    background-color: #eeeeee;
  }

  .cursor-pointer {
    margin-left: 6px !important;
  }

  :deep(.ant-descriptions-item-label) {
    text-align: right;
    width: 90px;
  }

  :deep(.ant-descriptions-item-content) {
    float: right;
    width: 350px;
  }
</style>
